export {Hotkey, parseHotkeys} from './Hotkey';
export type {HotkeyProps} from './Hotkey';
